import { APIKeyID, EmailImporterID, UserID } from "models";

export type RecallID = number;

export enum RECALL_STATUSES {
  ToBeFixed = "",
  Settled = "Settled",
  ToBeSettled = "To be settled",
  DealerSubmit = "Dealer Submit",
  Approved = "Approved",
  DraftSaved = "Draft Saved",
  Unknown = "Unknown"
}

export interface Recall {
  created_on: string;
  updated_on: string;
  id: RecallID; // Identifier of the recall
  campaign_code: string; // Code of the campaign
  campaign_name: string; // Name of the campaign
  campaign_type: string; // Type of the campaign
  start_date: string; // Start date of the campaign
  close_date: string; // Close date of the campaign
  release_date: string; // Release date of the campaign
  vin: string; // Vehicle Identification Number
  status: RECALL_STATUSES; // Status of the campaign
  buy_off_company: string; // Company name of the buy off company
  approval_company: string; // Company name of the approval company
  customer_id: number; // Identifier of the customer
  customer_en: string; // Name of the customer
  country: string; // Country
  vehicle_series: string; // Name of the vehicle series
  claim_order: string; // The identifier of the claim order
  repair_end_date: string | null; // End date of the repair
  approval_date: string | null; // Date of the approval
  email_importer_id?: EmailImporterID; // The identifier of who imported the email using email
  user_id?: UserID; // The identifier of who imported the recall using the website
  api_key_id?: APIKeyID; // The identifier of who imported the recall using the API
}
